import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=498c9374&scoped=true"
import script from "./Variant.vue?vue&type=script&lang=js"
export * from "./Variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c9374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498c9374')) {
      api.createRecord('498c9374', component.options)
    } else {
      api.reload('498c9374', component.options)
    }
    module.hot.accept("./Variant.vue?vue&type=template&id=498c9374&scoped=true", function () {
      api.rerender('498c9374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/Variant.vue"
export default component.exports